import React, {useState, useEffect} from 'react';
import { MasterDataGrid } from "@/components/";
import FollowupSubProjectPresenter from "../../../../../presenters/screens/followup-subproject.presenter";
import { IFollowupSubproject } from "@interfaces/screens/followup-subproject.interface";
import styles from './index.module.scss';
import { Utilities, Enums } from "@utils";
import Disaggregation from './disaggregation';

export interface ITotalsProps{    
    dataColumns: any;
	stepData: any;
	status: any;
	screen: any;
	columns: any;
	saveTable(instance: any): void;
	refresh: boolean;
	resData: any;
	overData: any;
	actData: any;
	tableAlert: string;
	currentYear: string;
}

const TotalSubproject: React.FC<any> = ({dataColumns, columns, screen, resData, refresh, overData, actData, tableAlert, status, currentYear, saveTable}: ITotalsProps) => {
    const [data, setData] = useState<any>(null);
	const [auxCol, setAuxCol] = useState<any>(null);

	const view: IFollowupSubproject = {
        state: {
			dataColumns
        },
    };

	const presenter = new FollowupSubProjectPresenter(view);

	useEffect(() => {
		let isSubscribed = true;
        if(columns?.totalSubPr) {
            let totalSubPr = getAuxColumns()
			setAuxCol(totalSubPr)
        }
		return () => {(isSubscribed = false)}
    }, [columns?.totalSubPr]);  

	useEffect(() => {
		let isSubscribed = true;
        const getData = async () => {
			if(presenter.stepTourBen > 1){
				let totalData = presenter.getTourData(10, Enums.FollowupDimensions.beneficiaries, currentYear)
				let totalAuxData = presenter.getTourData(12, Enums.FollowupDimensions.beneficiaries, currentYear)
				let dissagregateData = presenter.getTourData(13, Enums.FollowupDimensions.beneficiaries, currentYear)
				setData({totalData, totalAuxData, dissagregateData})
			}else if(resData && overData && presenter.beneficiariesData && actData) {
				let totalData = await presenter.getBeneficiariesTotalsData(resData, overData)
				let totalAuxData = presenter.getBeneficiariesTotalAuxData(actData, totalData, currentYear)
				let dissagregateData = await presenter.getBeneficiariesDissagregateData(totalData, data?.dissagregateData) 
				setData({totalData, totalAuxData, dissagregateData})
			}
		}
		getData()
		return () => {(isSubscribed = false)}
    }, [refresh, overData, resData, actData, presenter.beneficiariesData, presenter.stepTourBen]); 

	const getAuxColumns = () => {
		let auxCol = Utilities.copyObject(columns?.totalSubPr)
		auxCol = auxCol.filter((col: any) => {
			if(col?.columns?.length){
				for (const childCol of col.columns) {
					childCol.allowEditing = false
				}
			}
			col.allowEditing = false
			return col
		})
		return auxCol;
	}

	return (
		<div className={styles.divPpal}>
			{(data && auxCol) &&
				<>
					<MasterDataGrid 
						id={`beneficiaries-totals`}
						dataSource={data?.totalData?.data || []}
						columns={auxCol}
						allowCode={screen}
						gridTitle={presenter.followupLabels.get("beneficiariesByActivitiesTotalTitle")}
						gridProps={{
							editing:{ mode:"cell", allowUpdating:false, allowAdding: false, allowDeleting: false},
							rowAlternationEnabled:false,
							onContentReady: (data) => {
								if(data.component !== undefined){
									const row = data.component.getRowElement(data.component.getVisibleRows().length - 3);
									const row2 = data.component.getRowElement(data.component.getVisibleRows().length - 2);
									const row3 = data.component.getRowElement(data.component.getVisibleRows().length - 1);
									if(row !== undefined){
										row[0].classList.add(styles.subTotal);
									}
									if(row2 !== undefined){
										row2[0].classList.add(styles.totals);
									}
									if(row3 !== undefined){
										row3[0].classList.add(styles.totals);
									}
								}
							}
						}}
					/>
					<div className={styles.divPpal}>
						<MasterDataGrid 
							id={`beneficiaries-totals-footer`}
							dataSource={data?.totalAuxData?.data || []}
							columns={[]}
							allowCode={screen}
							gridProps={{
								showColumnHeaders: false,
								editing:{ mode:"cell", allowUpdating:false, allowAdding: false, allowDeleting: false},
								rowAlternationEnabled:true,
								showBorders: true,
								showColumnLines: true,
								width: 500,
								onContentReady: (data) => {
									if(data.component !== undefined){
										const row = data.component.getRowElement(data.component.getVisibleRows().length - 1);
										const row2 = data.component.getRowElement(data.component.getVisibleRows().length - 2);
										const row3 = data.component.getRowElement(data.component.getVisibleRows().length - 3);
										if(row !== undefined){                                
											row[0].childNodes.forEach((child:any) => {  
												child.classList.add(styles.textCenter);
											});
										}
										if(row2 !== undefined){                                
											row2[0].childNodes.forEach((child:any) => {  
												child.classList.add(styles.textCenter);
											});
										}
										if(row3 !== undefined){                                
											row3[0].childNodes.forEach((child:any) => {  
												child.classList.add(styles.textCenter);
											});
											row3[0].setAttribute("id", "BeneficiariesTourStep12")
										}
									}
								}
							}}
						/>
					</div>
					<Disaggregation
						dataColumns={dataColumns}
						columns={columns}
						status={status}
						screen={screen}
						tableAlert={tableAlert}
						saveTable={saveTable}
						data={data}
						refresh={refresh}
					/>
				</>
			}
		</div>
	);
}

export default TotalSubproject;